import React from "react";
import { mapAppVersionToDataTable as mapData } from "./Helper";
import ReusableDataTable from "src/components/table/ReusableDataTable";
import GetReleaseAppVersionColumns from "./ColumnDefinition/ReleaseAppVersionColumn/GetReleaseAppVersionColumns";

const ReleaseAppVersionTable = ({
  data,
  handleOpenPopup,
  handleChangeModeRelease,
  status,
}) => {
  const columns = GetReleaseAppVersionColumns({
    handleOpenPopup,
    handleChangeModeRelease,
    status,
  });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={500} />
  );
};

export default ReleaseAppVersionTable;
